<template>
    <div>
        <Title>基本信息</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>
            <div class="label">阶段</div>
            <div class="value1">
                <DataDictFinder dictType="cosys.designPhase" :dictValue="extra.phaseCode" />
            </div>
            <div class="label">专业</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.major" :dictValue="extra.fromMajorCode" />
            </div>
            <div class="label">会签编号</div>
            <div class="value1">{{ extra.signCode || '--' }}</div>

            <div class="label">成果数量</div>
            <div class="value2">{{ (extra.designResultFiles || []).length }} 个</div>
            <template v-if="extra.designResultFiles && extra.designResultFiles.length">
                <div class="label">成果名称</div>
                <div class="value1">{{ extra.designResultFiles[0].resultName || '--' }}</div>
                <div class="label">成果编号</div>
                <div class="value2">{{ extra.designResultFiles[0].resultNo || '--' }}</div>
                <div class="label">子项名称</div>
                <div class="value1">{{ extra.designResultFiles[0].subWbsName || '--' }}</div>
                <div class="label">子项编号</div>
                <div class="value2">{{ extra.designResultFiles[0].subWbsNo || '--' }}</div>
            </template>
        </div>
        <Title v-if="extra.oldFiles && extra.oldFiles.length">替换文件</Title>
        <div class="panel" v-if="extra.oldFiles && extra.oldFiles.length">
            <div class="value3" style="grid-column: 1 / 7;">
                <a-table
                    :data-source="replaceFileList"
                    :columns="replaceColumns"
                    :row-key="(r, i) => i"
                    :pagination="false"
                    bordered
                    size="small"
                >
                    <template slot="oldFileName" slot-scope="text, record">
                        <a v-if="record.oldFile && record.oldFile.completePath" @click.prevent="handleFileClick($event, record.oldFile.completePath, text)" class="file-link">{{ text }}</a>
                        <span v-else>{{ text }}</span>
                    </template>
                    <template slot="newFileName" slot-scope="text, record">
                        <a v-if="record.newFile && record.newFile.completePath" @click.prevent="handleFileClick($event, record.newFile.completePath, text)" class="file-link">{{ text }}</a>
                        <span v-else>{{ text }}</span>
                    </template>
                    <template slot="oldFileType" slot-scope="text">
                        <DataDictFinder dictType="cosys.cosys_file_type" :dictValue="text" />
                    </template>
                    <template slot="newFileType" slot-scope="text">
                        <DataDictFinder dictType="cosys.cosys_file_type" :dictValue="text" />
                    </template>
                    <template slot="oldIsSign" slot-scope="text">
                        {{ text ? '是' : '否' }}
                    </template>
                    <template slot="newIsSign" slot-scope="text">
                        {{ text ? '是' : '否' }}
                    </template>
                </a-table>
            </div>
            <div class="label">替换备注</div>
            <div class="value3">{{ extra.replaceRemark || '--' }}</div>
        </div>
        <Title>会签人员</Title>
        <div class="panel">
            <div class="label">会签人员</div>
            <div class="value3">
                <table class="signer-table" cellspacing="0">
                    <tr>
                        <th>专业</th>
                        <th>会签人</th>
                        <th>备注</th>
                    </tr>
                    <tr v-for="(s, i) in extra.signers" :key="i">
                        <td>
                            <DataDictFinder dictType="cosys.major" :dictValue="s.majorCode" />
                        </td>
                        <td>{{ s.signerName }}</td>
                        <td>{{ s.remark }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <Title v-if="resultFileList.length">设计成果文件</Title>
        <div class="panel" v-if="resultFileList.length">
            <div class="value3" style="grid-column: 1 / 7;">
                <a-table
                    :data-source="resultFileList"
                    :columns="resultColumns"
                    :row-key="record => record.resultId || record.fileId || (record.countersignId || '') + '_' + (record.fileId || '')"
                    :pagination="false"
                    bordered
                    size="small"
                    :expandedRowKeys="expandedRowKeys"
                    @expand="onExpand"
                >
                    <template slot="expandedRowRender" slot-scope="record">
                        <a-table
                            :data-source="record.selectedPages"
                            :columns="pageColumns"
                            :row-key="record => record.id || record.pageName + '_' + record.pageNumber"
                            :pagination="false"
                            bordered
                            size="small"
                        >
                            <template slot="pageName" slot-scope="text">
                                <a v-if="record.completePath" @click.prevent="handleFileClick($event, record.completePath, text)" class="file-link">{{ text }}</a>
                                <span v-else>{{ text }}</span>
                            </template>
                        </a-table>
                    </template>
                    <template slot="majorCode" slot-scope="text">
                        <DataDictFinder dictType="cosys.major" :dictValue="text" />
                    </template>
                    <template slot="auditEndDate" slot-scope="text">
                        {{ text | dateFormat }}
                    </template>
                    <template slot="selectedPagesCount" slot-scope="text, record">
                        {{ (record.selectedPages && record.selectedPages.length) || 0 }}
                    </template>
                    <template slot="fileName" slot-scope="text, record">
                        <a v-if="record.completePath" @click.prevent="handleFileClick($event, record.completePath, text)" class="file-link">{{ text }}</a>
                        <span v-else>{{ text }}</span>
                    </template>
                </a-table>
            </div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
import { listPagesByFileId } from "@/api/project-design/countersign";
export default {
    components: {
        Title,
    },
    data() {
        return {
            expandedRowKeys: [],
            resultFileList: [],
            replaceColumns: [
                { title: '原文件名', dataIndex: 'oldFileName', ellipsis: true, scopedSlots: { customRender: 'oldFileName' } },
                { title: '文件类型(原)', dataIndex: 'oldFileType', width: 120, scopedSlots: { customRender: 'oldFileType' } },
                { title: '是否签章(原)', dataIndex: 'oldIsSign', width: 110, scopedSlots: { customRender: 'oldIsSign' } },
                { title: '替换文件名', dataIndex: 'newFileName', ellipsis: true, scopedSlots: { customRender: 'newFileName' } },
                { title: '文件类型(替换)', dataIndex: 'newFileType', width: 120, scopedSlots: { customRender: 'newFileType' } },
                { title: '是否签章(替换)', dataIndex: 'newIsSign', width: 120, scopedSlots: { customRender: 'newIsSign' } },
            ],
            resultColumns: [
                { title: '成果编号', dataIndex: 'resultNo', width: 100 },
                { title: '成果名称', dataIndex: 'resultName', ellipsis: true },
                { title: '文件名称', dataIndex: 'fileName', ellipsis: true, scopedSlots: { customRender: 'fileName' } },
                { title: '专业', dataIndex: 'majorCode', width: 80, scopedSlots: { customRender: 'majorCode' } },
                { title: '页数', dataIndex: 'pageCount', width: 60 },
                { title: '选择页数', key: 'selectedPagesCount', width: 80, scopedSlots: { customRender: 'selectedPagesCount' } },
                { title: '审核期限', dataIndex: 'auditEndDate', width: 110, scopedSlots: { customRender: 'auditEndDate' } },
                { title: '子项名称', dataIndex: 'subWbsName', ellipsis: true },
                { title: '子项编号', dataIndex: 'subWbsNo', width: 100 },
            ],
            pageColumns: [
                { title: '页面名称', dataIndex: 'pageName', ellipsis: true, scopedSlots: { customRender: 'pageName' } },
                { title: '页码', dataIndex: 'pageNumber', width: 60 },
                { title: '页数', dataIndex: 'pageCount', width: 60 },
                { title: '图号', dataIndex: 'drawingNo', width: 120 },
            ],
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        replaceFileList() {
            const oldFiles = this.extra.oldFiles || [];
            const newFiles = this.extra.newFiles || [];
            const maxLen = Math.max(oldFiles.length, newFiles.length);
            const list = [];
            for (let i = 0; i < maxLen; i++) {
                const oldFile = oldFiles[i] || {};
                const newFile = newFiles[i] || {};
                list.push({
                    oldFileName: oldFile.name || '--',
                    oldFileType: oldFile.type || '--',
                    oldIsSign: oldFile.isSign,
                    newFileName: newFile.name || '--',
                    newFileType: newFile.type || '--',
                    newIsSign: newFile.isSign,
                    oldFile,
                    newFile,
                });
            }
            return list;
        },
    },
    watch: {
        'extra.designResultFiles': {
            immediate: true,
            handler(files) {
                if (files && files.length) {
                    this.resultFileList = files.map(f => ({
                        ...f,
                        selectedPages: (f.selectedPages || []).map(p => ({
                            ...p,
                            attachment: this.parseAttachment(p.attachment),
                        })),
                        _pagesLoaded: !!f.selectedPages,
                    }));
                } else {
                    this.resultFileList = [];
                }
            },
        },
    },
    methods: {
        parseAttachment(attachment) {
            if (!attachment) return null;
            if (typeof attachment === 'object') return attachment;
            // try JSON.parse first
            try {
                return JSON.parse(attachment);
            } catch (e) {
                // if JSON.parse fails, try extracting url via regex from the raw string
                const match = attachment.match(/"url"\s*:\s*"([^"]+)"/);
                if (match) {
                    return { id: '', url: match[1] };
                }
                // if the string itself looks like a URL, use it directly
                if (/^https?:\/\//.test(attachment)) {
                    return { id: '', url: attachment };
                }
                return null;
            }
        },
        async onExpand(expanded, record) {
            if (expanded) {
                this.expandedRowKeys = [record.resultId || record.fileId];
                if (!record._pagesLoaded && record.fileId) {
                    try {
                        const pages = await listPagesByFileId(record.fileId);
                        const idx = this.resultFileList.findIndex(r => (r.resultId || r.fileId) === (record.resultId || record.fileId));
                        if (idx > -1) {
                            const updated = { ...this.resultFileList[idx], selectedPages: Array.isArray(pages) ? pages : [], _pagesLoaded: true };
                            this.$set(this.resultFileList, idx, updated);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            } else {
                this.expandedRowKeys = [];
            }
        },
        getAttachmentInfo(attachment) {
            if (!attachment) return null;
            // already an object
            if (typeof attachment === 'object') {
                const url = attachment.url || '';
                if (!url) return null;
                const fullUrl = url.split('?')[0];
                const filename = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);
                return { url, filename };
            }
            // string - try to parse as JSON
            try {
                const parsed = JSON.parse(attachment);
                const url = parsed.url || '';
                if (!url) return null;
                const fullUrl = url.split('?')[0];
                const filename = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);
                return { url, filename };
            } catch (e) {
                return null;
            }
        },
        getAttachmentUrl(attachment) {
            const info = this.getAttachmentInfo(attachment);
            return info ? info.url : '';
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            event.preventDefault();
            const decodedUrl = this.deepDecodeURIComponent(url);
            if (this.isPdfFile(filename)) {
                this.previewPdf(decodedUrl, filename);
            } else {
                const a = document.createElement('a');
                a.href = decodedUrl;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
    },
    filters: {
        dateFormat(val) {
            if (!val) return '-';
            return new Date(val).toLocaleDateString();
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .signer-table {
        width: 100%;
        th, td {
            padding: 8px;
            border: 1px solid #d9d9d9;
            min-width: 100px;
        }
        th {
            background-color: #f9f9f9;
        }
    }

    .file-item {
        margin-bottom: 4px;
        &:last-child { margin-bottom: 0; }
    }
}
</style>
